export const CHAVE_USUARIO = '__USUARIO_LOGIN__';
export const CHVAE_TOKEN = '__TOKEN__';

export const localeCalendarBR = {
    firstDayOfWeek: 1,
    dayNames: [ "Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado" ],
    dayNamesShort: [ "Dom","Seg","Ter","Qua","Qui","Sex","Sáb" ],
    dayNamesMin: [ "Dom","Seg","Ter","Qua","Qui","Sex","Sáb" ],
    monthNames: [ "Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro" ],
    monthNamesShort: [ "Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez" ],
    today: 'Hoje',
    clear: 'Limpar',
    weekHeader: 'Sm'
}

export const acoesSolicitacoesPendentes = [{ nome:'Aprovar', id: 'Aprovado' }, { nome:'Não Aprovar', id: 'Não Aprovado' }];

export function exibirMensagem(vue, dataResp) {   
    if(dataResp && dataResp.response && dataResp.response.data) {        
        if(dataResp.response.status == 400 || dataResp.response.status == 401) {
            vue.$toast.add({severity:'warn', summary: 'Mensagem', detail: dataResp.response.data.mensagem, life: 10000});
        } else {
            vue.$toast.add({severity:'error', summary: 'Erro', detail: 'Oops! Algo deu errado!', life: 10000});
        }
    } else if(dataResp.status && dataResp.status == 200)  {
        vue.$toast.add({severity:'success', summary: 'OK', detail: dataResp.data.mensagem, life: 10000});
    } else {
        vue.$toast.add({severity:'error', summary: 'Erro', detail: 'Oops! Algo deu errado!', life: 10000});
    }
}

export function exibirMensagemSis(vue, mensagem, erro) {   
    if(!erro) {        
        vue.$toast.add({severity:'success', summary: 'OK', detail: mensagem, life: 10000});
    } else {
        vue.$toast.add({severity:'warn', summary: 'Mensagem', detail: mensagem, life: 10000});
    }
}

export default { CHAVE_USUARIO, CHVAE_TOKEN };